import { HttpStatusCode } from "axios";
import { alertConstants } from "../../helper/sweet-alert";
import StudentResourceService from "../../apiServices/masters/studentResourceService";
import { setStudentResource, setStudentResources } from "../../store/slices/master/studentResourceSlice";

export function getStudentResource(id: number) {
  return async function (dispatch: any, getState: any) {
    let response = await StudentResourceService.getStudentResource(id);
    if (response?.success === true) {
      dispatch(setStudentResource(response.data));
    } else {
      console.log("error");
    }
  };
}

export function getStudentResources(configUserRole?: number) {
  return async function (dispatch: any, getState: any) {
    let response = await StudentResourceService.getStudentResources(configUserRole);
    if (response?.success === true) {
      dispatch(setStudentResources(response.data));
    } else {
      console.log("error");
    }
  };
}

export function createStudentResource(data: any, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await StudentResourceService.createStudentResource(data);
    const name = data.get("name")
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict, name);
      }
      else {
        callback(alertConstants.error);
      }
    }
  };
}

export function updateStudentResource(data: any, id: number, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await StudentResourceService.updateStudentResource(data, id);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict);
      } else {
        callback(alertConstants.error);
      }
    }
  };
}

export function updateStudentResourcePriority(data: any, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await StudentResourceService.updateStudentResourcePriority(data);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      callback(alertConstants.error);
    }
  };
}
export function deleteStudentResource(id: number, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await StudentResourceService.deleteStudentResource(id);
    if (response === true) {
      callback(alertConstants.inactiveSuccess);
    } else {
      callback(alertConstants.inactiveFailure);
    }
  };
}
